import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export const trackShortenedUrlAccess = (url: URL) => {
  trackEvent(keys.shortenedUrlAccessed, { redirecturl: url.toString() })
}
